/** A field to type in: an input, a text area, or editable text such as a rich composer. */
export const TEXT_ENTRY_SELECTOR = "input, textarea, [contenteditable='true'], [contenteditable='plaintext-only']";

/**
 * Whether a right-click keeps the browser's own context menu: it landed in a field to type in, whose menu copies,
 * pastes, and spell-checks. A page that owns the right-click everywhere else leaves these alone.
 *
 * @param target - The event's target; anything that is not an element, such as a text node or null, keeps nothing.
 */
export function keepsBrowserMenu(target: EventTarget | null): boolean {
  if (target === null || !("closest" in target) || typeof target.closest !== "function") return false;
  return target.closest(TEXT_ENTRY_SELECTOR) !== null;
}
